module.exports = __webpack_public_path__ + "img/placenta-marginal.ae1a2871.png";